import { Typography } from "@/components";
import { isMpisAccount } from "@/libraries/helper";
import EmptyPeoples from "@/routes/dashboard/contacts/-components/EmptyPeoples";
import type { InviteCaseMemberSearchParamSchema } from "@/schemas";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useNavigate } from "@tanstack/react-router";
import { Route } from "../contact";

const ReferralContactError = () => {
	const navigate = useNavigate();
	const tab = Route.useSearch({
		select: (s: InviteCaseMemberSearchParamSchema) => s.tab,
	});
	const handleChangeTab = (
		e: React.SyntheticEvent,
		newValue: InviteCaseMemberSearchParamSchema["tab"],
	) => {
		e.preventDefault();
		return navigate({
			search: {
				// @ts-expect-error
				tab: newValue,
			},
			replace: true,
		});
	};
	return (
		<>
			<div className="container flex flex-col gap-4">
				<Typography fontWeight={900} fontSize={14}>
					Select one of your contact:
				</Typography>
				<Tabs
					centered
					value={tab}
					variant="fullWidth"
					textColor="inherit"
					aria-label="Contact Type"
					className="!rounded-full !bg-gray-light [&_.MuiTabs-indicator]:!bg-transparent !p-1"
					onChange={handleChangeTab}
				>
					<Tab
						value="contact"
						label="Contacts"
						classes={{
							selected: "!bg-white !rounded-full",
						}}
					/>
					<Tab
						value="directory"
						label="Directory"
						classes={{
							selected: "!bg-white !rounded-full",
						}}
					/>
					{isMpisAccount() ? (
						<Tab
							value="mpis"
							label="MPIS"
							classes={{
								selected: "!bg-white !rounded-full",
							}}
						/>
					) : null}
				</Tabs>
			</div>
			<div className="flex-1 relative overflow-y-auto">
				<EmptyPeoples
					title="Unlock the Professional Directory"
					message="Upgrade your plan to access verified and pro contacts in the directory. Expand your network today!"
					withButton={true}
					buttonLabel="Upgrade Now"
					buttonProps={{
						startIcon: <ArrowCircleUpIcon />,
						onClick: () =>
							navigate({
								to: "/subscription",
							}),
					}}
				/>
			</div>
		</>
	);
};

export default ReferralContactError;
